/* eslint-disable */
const getters = {
  getUser(state) {
    return state.user;
  },

  getIsSuper(state, getters) {
    return getters.getUser.authority === 1;
  },

  getToken(state) {
    return state.token;
  },
};

export default getters;
